<mat-card [ngClass]="{'unrounded': unrounded()}">
    <ng-content></ng-content>
</mat-card>
